var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Archive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "archive/Outlined",
    transform: "translate(3, 3)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6933339,1.48666668 L10.7666664,0.366666635 C10.5866664,0.139999966 10.3133333,0 10,0 L2,0 C1.68666667,0 1.41333344,0.139999966 1.22666677,0.366666635 L0.306666692,1.48666668 C0.113333364,1.71333335 0,2.01333334 0,2.33333333 L0,10.6666667 C0,11.4 0.599999984,12 1.33333333,12 L10.6666667,12 C11.4,12 12,11.4 12,10.6666667 L12,2.33333333 C12,2.01333334 11.8866673,1.71333335 11.6933339,1.48666668 Z M2.15999985,1.33333333 L9.84000015,1.33333333 L10.3799998,1.97999986 L1.6266667,1.97999986 L2.15999985,1.33333333 Z M1.33333333,10.6666667 L1.33333333,3.33333333 L10.6666667,3.33333333 L10.6666667,10.6666667 L1.33333333,10.6666667 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.65833588,10.0800527 L11.3938097,10.0800527 L9.46559505,8.03179735 M11.3938097,10.0800527 L9.44206011,12.0761625",
    id: "Vector",
    stroke: "#0A186E",
    strokeWidth: 1.1,
    opacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(9.0261, 10.054) rotate(90) translate(-9.0261, -10.054)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Archive.4c8fe6d8ab8082d4645a2e5ecee29b6d.svg";